const TitulosSeccions = ({ cssStyle, title }) => {
  return <p className={cssStyle}>{title}</p>;
};

export default TitulosSeccions;
